module.exports = __webpack_public_path__ + "static/img/image074.33ffc94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image074.png
// module id = Q7L7
// module chunks = 1